import React from 'react'
import logo1 from '../../assets/SettingsPage/SVG/codicon_account.svg'
import logo2 from '../../assets/SettingsPage/SVG/cil_lock-locked.svg'
import logo3 from '../../assets/SettingsPage/SVG/la_user-friends.svg'
import logo4 from '../../assets/SettingsPage/SVG/icon-park-outline_agreement.svg'
import logo5 from '../../assets/SettingsPage/SVG/ant-design_logout-outlined.svg'
import SettingsPost from '../Components/SettingsPost'
import './SettingsPage.css'
import { useNavigate } from 'react-router-dom'
import Arrow from '../../assets/SettingsPage/SVG/Arrow 1.svg';

function SettingsPage() {
  const navigate = useNavigate()

  return (
    <div className="surgesetting-container">
      <div className='surgesettings-header'>
        <div className='row' style={{ justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
          <div style={{ width: 40 }} onClick={() => window.history.go(-1)}>
            <img src={Arrow} />
          </div>
          <h3 style={{ textAlign: 'center' }}>Settings</h3>
          <div style={{ width: 20 }}></div>
        </div>

      </div>
      <div className="surgesetting-components">
        <SettingsPost url={logo1} text="Account Settings" />
        <SettingsPost url={logo2} text="Security" />
        <SettingsPost url={logo3} text="Crews" />
        <SettingsPost url={logo4} text="About" />
        <SettingsPost url={logo4} text="Review us" />
        <SettingsPost url={logo5} text="Logout" />
        <SettingsPost url={logo5} text="Delete Account" />
      </div>
    </div>
  )
}

export default SettingsPage